import React from 'react'
import ReactDOM from 'react-dom/client'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import theme from './theme'
import { Provider } from 'react-redux'
import { store } from './store'
import { TextureProvider } from './context/EnhancedTextureContext'
import App from './App'
import './index.css'
import './styles/checkbox-enhanced.css' // Import enhanced checkbox styles for better visibility

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful:', registration.scope);
        
        // Set up periodic sync for cache cleanup if supported
        if ('periodicSync' in registration) {
          registration.periodicSync.register('clean-expired-cache', {
            minInterval: 24 * 60 * 60 * 1000, // 24 hours
          }).catch(error => {
            console.log('Periodic Sync could not be registered:', error);
          });
        }
      })
      .catch(err => {
        console.log('ServiceWorker registration failed:', err);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <TextureProvider>
          <App />
        </TextureProvider>
      </ChakraProvider>
    </Provider>
  </React.StrictMode>
)
